import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

let removeIcon;

class VideoListItem extends React.Component {
  handleVideoItemClick(event) {
    if (event.target === removeIcon || removeIcon.contains(event.target)) {
      return;
    }
    this.props.handleVideoSelection(this.props.video);
  }

  render() {
    return (
      <li
        className={classNames(
          'video-list__item',
          { 'video-list__item--selected': this.props.isSelected },
        )}
        onClick={event => this.handleVideoItemClick(event)}
      >
        <button
          className="video-list__item__remove"
          onClick={() => this.props.handleVideoRemove(this.props.video)}
          ref={DOMNode => (removeIcon = DOMNode)}
        >
          <i className="fa fa-times-circle-o" />
        </button>
        <div className="video-list__item__video-frame">
          <iframe
            title="listing-video"
            frameBorder="0"
            allowFullScreen
            src={`https://www.youtube.com/embed/${this.props.video.id.videoId}?modestbranding=1&showinfo=0&controls=2&iv_load_policy=3&rel=0`} />
        </div>
        <p className="video-list__item__title">
          {this.props.video.snippet.title}
        </p>
        <p className="video-list__item__publisher">
          {I18n.t(
            'js.listingForm.videos.byChannelTitle',
            { channel_title: this.props.video.snippet.channelTitle },
          )
          }
        </p>
      </li>
    );
  }
}

VideoListItem.propTypes = {
  video: PropTypes.object.isRequired,
  handleVideoSelection: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleVideoRemove: PropTypes.func.isRequired,
};

export default VideoListItem;
